export const GET_ESSAYS_REQUEST = 'essaysReducer/GET_ESSAYS_REQUEST';
export const GET_ESSAYS_SUCCESS = 'essaysReducer/GET_ESSAYS_SUCCESS';
export const GET_ESSAYS_FAILED = 'essaysReducer/GET_ESSAYS_FAILED';
